module.exports = __webpack_public_path__ + "media/vectors/term-bg-5-0d1f35ee.jpg";